import { render } from "./ViajeFamiliar.vue?vue&type=template&id=6f5a644b"
import script from "./ViajeFamiliar.vue?vue&type=script&lang=js"
export * from "./ViajeFamiliar.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__